var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.callTypes),function(callType){return [(_vm.value === callType.value)?_c('VChip',{key:callType.value,attrs:{"color":callType.color,"label":"","small":""}},[_vm._v(" "+_vm._s(callType.name)+" ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }